/* eslint-disable @typescript-eslint/no-explicit-any */

// ---------------------------------------------------------------------------
// Slugify character maps (ported from reactivex-backend StringService)
// ---------------------------------------------------------------------------

const CHAR_MAP: Record<string, string> = {
  $: 'dollar',
  '%': 'percent',
  '&': 'and',
  '<': 'less',
  '>': 'greater',
  '|': 'or',
  '¢': 'cent',
  '£': 'pound',
  '¤': 'currency',
  '¥': 'yen',
  '©': '(c)',
  ª: 'a',
  '®': '(r)',
  º: 'o',
  // Latin
  À: 'A',
  Á: 'A',
  Â: 'A',
  Ã: 'A',
  Ä: 'A',
  Å: 'A',
  Æ: 'AE',
  Ç: 'C',
  È: 'E',
  É: 'E',
  Ê: 'E',
  Ë: 'E',
  Ì: 'I',
  Í: 'I',
  Î: 'I',
  Ï: 'I',
  Ð: 'D',
  Ñ: 'N',
  Ò: 'O',
  Ó: 'O',
  Ô: 'O',
  Õ: 'O',
  Ö: 'O',
  Ø: 'O',
  Ù: 'U',
  Ú: 'U',
  Û: 'U',
  Ü: 'U',
  Ý: 'Y',
  Þ: 'TH',
  ß: 'ss',
  à: 'a',
  á: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  å: 'a',
  æ: 'ae',
  ç: 'c',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  ì: 'i',
  í: 'i',
  î: 'i',
  ï: 'i',
  ð: 'd',
  ñ: 'n',
  ò: 'o',
  ó: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  ø: 'o',
  ù: 'u',
  ú: 'u',
  û: 'u',
  ü: 'u',
  ý: 'y',
  þ: 'th',
  ÿ: 'y',
  // Extended Latin
  Ā: 'A',
  ā: 'a',
  Ă: 'A',
  ă: 'a',
  Ą: 'A',
  ą: 'a',
  Ć: 'C',
  ć: 'c',
  Č: 'C',
  č: 'c',
  Ď: 'D',
  ď: 'd',
  Đ: 'DJ',
  đ: 'dj',
  Ē: 'E',
  ē: 'e',
  Ė: 'E',
  ė: 'e',
  Ę: 'e',
  ę: 'e',
  Ě: 'E',
  ě: 'e',
  Ğ: 'G',
  ğ: 'g',
  Ģ: 'G',
  ģ: 'g',
  Ĩ: 'I',
  ĩ: 'i',
  Ī: 'i',
  ī: 'i',
  Į: 'I',
  į: 'i',
  İ: 'I',
  ı: 'i',
  Ķ: 'k',
  ķ: 'k',
  Ļ: 'L',
  ļ: 'l',
  Ľ: 'L',
  ľ: 'l',
  Ł: 'L',
  ł: 'l',
  Ń: 'N',
  ń: 'n',
  Ņ: 'N',
  ņ: 'n',
  Ň: 'N',
  ň: 'n',
  Ō: 'O',
  ō: 'o',
  Ő: 'O',
  ő: 'o',
  Œ: 'OE',
  œ: 'oe',
  Ŕ: 'R',
  ŕ: 'r',
  Ř: 'R',
  ř: 'r',
  Ś: 'S',
  ś: 's',
  Ş: 'S',
  ş: 's',
  Š: 'S',
  š: 's',
  Ţ: 'T',
  ţ: 't',
  Ť: 'T',
  ť: 't',
  Ũ: 'U',
  ũ: 'u',
  Ū: 'u',
  ū: 'u',
  Ů: 'U',
  ů: 'u',
  Ű: 'U',
  ű: 'u',
  Ų: 'U',
  ų: 'u',
  Ŵ: 'W',
  ŵ: 'w',
  Ŷ: 'Y',
  ŷ: 'y',
  Ÿ: 'Y',
  Ź: 'Z',
  ź: 'z',
  Ż: 'Z',
  ż: 'z',
  Ž: 'Z',
  ž: 'z',
  Ə: 'E',
  ƒ: 'f',
  Ơ: 'O',
  ơ: 'o',
  Ư: 'U',
  ư: 'u',
  ǈ: 'LJ',
  ǉ: 'lj',
  ǋ: 'NJ',
  ǌ: 'nj',
  Ș: 'S',
  ș: 's',
  Ț: 'T',
  ț: 't',
  ə: 'e',
  '˚': 'o',
  // Greek
  Ά: 'A',
  Έ: 'E',
  Ή: 'H',
  Ί: 'I',
  Ό: 'O',
  Ύ: 'Y',
  Ώ: 'W',
  ΐ: 'i',
  Α: 'A',
  Β: 'B',
  Γ: 'G',
  Δ: 'D',
  Ε: 'E',
  Ζ: 'Z',
  Η: 'H',
  Θ: '8',
  Ι: 'I',
  Κ: 'K',
  Λ: 'L',
  Μ: 'M',
  Ν: 'N',
  Ξ: '3',
  Ο: 'O',
  Π: 'P',
  Ρ: 'R',
  Σ: 'S',
  Τ: 'T',
  Υ: 'Y',
  Φ: 'F',
  Χ: 'X',
  Ψ: 'PS',
  Ω: 'W',
  Ϊ: 'I',
  Ϋ: 'Y',
  ά: 'a',
  έ: 'e',
  ή: 'h',
  ί: 'i',
  ΰ: 'y',
  α: 'a',
  β: 'b',
  γ: 'g',
  δ: 'd',
  ε: 'e',
  ζ: 'z',
  η: 'h',
  θ: '8',
  ι: 'i',
  κ: 'k',
  λ: 'l',
  μ: 'm',
  ν: 'n',
  ξ: '3',
  ο: 'o',
  π: 'p',
  ρ: 'r',
  ς: 's',
  σ: 's',
  τ: 't',
  υ: 'y',
  φ: 'f',
  χ: 'x',
  ψ: 'ps',
  ω: 'w',
  ϊ: 'i',
  ϋ: 'y',
  ό: 'o',
  ύ: 'y',
  ώ: 'w',
  // Cyrillic (non-locale-specific)
  Ё: 'Yo',
  Ђ: 'DJ',
  Є: 'Ye',
  І: 'I',
  Ї: 'Yi',
  Ј: 'J',
  Љ: 'LJ',
  Њ: 'NJ',
  Ћ: 'C',
  Џ: 'DZ',
  А: 'A',
  Б: 'B',
  В: 'V',
  Г: 'G',
  Д: 'D',
  Е: 'E',
  Ж: 'Zh',
  З: 'Z',
  И: 'I',
  Й: 'J',
  К: 'K',
  Л: 'L',
  М: 'M',
  Н: 'N',
  О: 'O',
  П: 'P',
  Р: 'R',
  С: 'S',
  Т: 'T',
  У: 'U',
  Ф: 'F',
  Х: 'H',
  Ц: 'C',
  Ч: 'Ch',
  Ш: 'Sh',
  Щ: 'Sh',
  Ъ: 'U',
  Ы: 'Y',
  Ь: '',
  Э: 'E',
  Ю: 'Yu',
  Я: 'Ya',
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'j',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'h',
  ц: 'c',
  ч: 'ch',
  ш: 'sh',
  щ: 'sh',
  ъ: 'u',
  ы: 'y',
  ь: '',
  э: 'e',
  ю: 'yu',
  я: 'ya',
  ё: 'yo',
  ђ: 'dj',
  є: 'ye',
  і: 'i',
  ї: 'yi',
  ј: 'j',
  љ: 'lj',
  њ: 'nj',
  ћ: 'c',
  ѝ: 'u',
  џ: 'dz',
  // Other
  Ґ: 'G',
  ґ: 'g',
  Ғ: 'GH',
  ғ: 'gh',
  Қ: 'KH',
  қ: 'kh',
  Ң: 'NG',
  ң: 'ng',
  Ү: 'UE',
  ү: 'ue',
  Ұ: 'U',
  ұ: 'u',
  Һ: 'H',
  һ: 'h',
  Ә: 'AE',
  ә: 'ae',
  Ө: 'OE',
  ө: 'oe',
  // Currency / symbols
  '\u20BF': 'bitcoin',
  '\u20BD': 'russian ruble',
  '\u20ba': 'turkish lira',
  '\u20b9': 'indian rupee',
  '\u20b8': 'kazakhstani tenge',
  '\u20A3': 'french franc',
  '\u20AC': 'euro',
  '\u2122': 'tm',
  '\u2120': 'sm',
  // Punctuation / typography
  '\u2013': '-',
  '\u2018': "'",
  '\u2019': "'",
  '\u201C': '"',
  '\u201D': '"',
  '\u201E': '"',
  '\u2020': '+',
  '\u2022': '*',
  '\u2026': '...',
};

const LOCALE_MAP: Record<string, Record<string, string>> = {
  bg: { Й: 'Y', Ц: 'Ts', Щ: 'Sht', Ъ: 'A', Ь: 'Y', й: 'y', ц: 'ts', щ: 'sht', ъ: 'a', ь: 'y' },
  de: { Ä: 'AE', ä: 'ae', Ö: 'OE', ö: 'oe', Ü: 'UE', ü: 'ue', ß: 'ss' },
  fr: {},
  es: {},
};

// ---------------------------------------------------------------------------
// Slugify
// ---------------------------------------------------------------------------

/**
 * Pure slugify function — ported from the backend `StringService`, no DI required.
 *
 * Transliterates Cyrillic, Greek, and many other scripts to Latin and
 * produces a URL-safe dash-case string.
 *
 * @example
 *   slugify('Лазери и Абканти', { locale: 'bg' })
 *   // => 'lazeri-i-abkanti'
 */
export function slugify(
  value: string,
  options: {
    replacement?: string;
    remove?: RegExp;
    lower?: boolean;
    strict?: boolean;
    locale?: string;
    trim?: boolean;
  } = {}
): string {
  if (typeof value !== 'string') return '';

  const locale = LOCALE_MAP[options.locale ?? ''] ?? {};
  const replacement = options.replacement ?? '-';
  const doTrim = options.trim !== false;

  let slug = value
    .normalize()
    .split('')
    .reduce((result, ch) => {
      let mapped = locale[ch] ?? CHAR_MAP[ch] ?? ch;
      if (mapped === replacement) mapped = ' ';
      return result + mapped.replace(options.remove ?? /[^\w\s$*_+~.()'"\-:@]+/g, '');
    }, '');

  if (options.strict) slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
  if (doTrim) slug = slug.trim();

  slug = slug.replace(/\s+/g, replacement);

  if (options.lower !== false) slug = slug.toLowerCase();

  return slug;
}

// ---------------------------------------------------------------------------
// Transform registry
// ---------------------------------------------------------------------------

export type BuiltInTransform = 'slugify' | 'uppercase' | 'lowercase' | 'prefix' | 'regexReplace';

/**
 * Apply a named transform to a value string.
 *
 * Built-in transforms:
 * - `'slugify'`     → Cyrillic/special → latin dash-case (args: `{ locale }`)
 * - `'uppercase'`   → `.toUpperCase()`
 * - `'lowercase'`   → `.toLowerCase()`
 * - `'prefix'`      → prepend `args.prefix`
 * - `'regexReplace'`→ `value.replace(pattern, replacement)` (args: `{ pattern, replacement, flags }`)
 *
 * @example
 *   applyTransform('slugify', 'Лазери и Абканти', { locale: 'bg' })
 *   // => 'lazeri-i-abkanti'
 */
export function applyTransform(transform: string, value: any, args?: Record<string, string>): string {
  const str = value == null ? '' : String(value);

  switch (transform as BuiltInTransform) {
    case 'slugify':
      return slugify(str, { locale: args?.locale ?? 'bg', lower: true, trim: true });

    case 'uppercase':
      return str.toUpperCase();

    case 'lowercase':
      return str.toLowerCase();

    case 'prefix':
      return (args?.prefix ?? '') + str;

    case 'regexReplace': {
      if (!args?.pattern) return str;
      const regex = new RegExp(args.pattern, args.flags ?? 'g');
      return str.replace(regex, args.replacement ?? '');
    }

    default:
      console.warn(`[DynamicForm] Unknown transform: "${transform}". Returning raw value.`);
      return str;
  }
}
